import React from 'react'
import useFetch from '../../Hooks/useFetch'
import mapboxgl from 'mapbox-gl'

mapboxgl.accessToken =
  'pk.eyJ1IjoibWFwYm94IiwiYSI6ImNpejY4M29iazA2Z2gycXA4N2pmbDZmangifQ.-g_vE53SD2WrJ6tFX7QHmA'

class Map extends React.Component {
  constructor(props) {
    // const { loading, error, data } = useFetch('projectlists')
    // console.log(data?.[0].Communityfeature)
    super(props)
    this.state = {
      lng: 73.099501,
      lat: 33.522117,
      zoom: 14,
    }
  }

  componentDidMount() {
    const { lng, lat, zoom } = this.state

    const map = new mapboxgl.Map({
      container: this.mapContainer,
      style: 'mapbox://styles/mapbox/light-v10',
      center: [lng, lat],
      zoom,
    })

    map.on('move', () => {
      const { lng, lat } = map.getCenter()

      this.setState({
        lng: lng.toFixed(4),
        lat: lat.toFixed(4),
        zoom: map.getZoom().toFixed(2),
      })
    })
  }

  render() {
    const { lng, lat, zoom } = this.state

    return (
      <div>
        {/* <div className="inline-block absolute top left mt12 ml12 bg-darken75 color-white z1 py6 px12 round-full txt-s txt-bold">
          <div>{`Longitude: ${lng} Latitude: ${lat} Zoom: ${zoom}`}</div>
        </div> */}
        <div
          style={{ height: '60vh' }}
          ref={(el) => (this.mapContainer = el)}
          className='absolute top right left bottom'
        />
      </div>
    )
  }
}

export default function MapSection({ projectNumber }) {
  const { data } = useFetch()
  // console.log(data?.[0].Mapsection.location)
  return (
    <div style={{ width: '100%', height: '60vh' }}>
      {/* <div id="gmap" /> */}
      {/* <Map /> */}
      {projectNumber?.fields.msLocation && (
        <div
          style={{ width: '100%', height: '100%' }}
          dangerouslySetInnerHTML={{
            __html: projectNumber?.fields.msLocation,
          }}
        ></div>
      )}{' '}
    </div>
  )
}
